import { Theme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Button(theme: Theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            boxShadow: "none",
          },
          borderRadius: "8px",
          textTransform: "none",
        },
        sizeLarge: {
          height: 48,
          lineHeight: 1,
          boxSizing: "border-box",
          fontSize: "16px",
          padding: "10px 32px",
          [theme.breakpoints.down("sm")]: {
            height: 40,
            fontSize: "14px",
            padding: "8px 20px",
          },
        },
        sizeMedium: {
          height: 40,
          lineHeight: 1,
          boxSizing: "border-box",
          fontSize: "14px",
          padding: "8px 16px",
          [theme.breakpoints.down("sm")]: {
            height: 36,
            fontSize: "12px",
            padding: "8px 14px",
          },
        },
        sizeSmall: {
          height: 32,
          lineHeight: 1,
          boxSizing: "border-box",
          fontSize: "12px",
          padding: "6px 12px",
          [theme.breakpoints.down("sm")]: {
            height: 32,
            fontSize: "12px",
            padding: "6px 12px",
          },
        },
        // contained
        containedInherit: {
          color: theme.palette.grey[200],

          boxShadow: theme.customShadows.z8,
          "&:hover": {
            backgroundColor: theme.palette.grey[400],
          },
        },
        containedPrimary: {
          backgroundColor: theme.palette.primary.light,
          borderRadius: "8px",
          fontSize: "16px",
        },
        containedSecondary: {
          bgcolor: theme.palette.secondary.main,
          color: theme.palette.secondary.contrastText,
          "&:hover": {
            backgroundColor: theme.palette.secondary.dark,
          },
        },
        containedInfo: {
          boxShadow: theme.customShadows.info,
        },
        containedSuccess: {
          boxShadow: theme.customShadows.success,
        },
        containedWarning: {
          boxShadow: theme.customShadows.warning,
        },
        containedError: {
          boxShadow: theme.customShadows.error,
        },
        // outlined
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[100]}`,
          color: theme.palette.text.secondary,
          "&:hover": {
            backgroundColor: theme.palette.action.selected,
          },
        },
        outlined: {
          border: `1px solid ${theme.palette.primary.light}`,
          color: theme.palette.text.secondary,
          borderRadius: "8px",
        },
        outlinedError: {
          border: `1px solid ${theme.palette.error.dark}`,
          color: theme.palette.error.dark,
          "&:hover": {
            backgroundColor: theme.palette.error.lighter,
            border: `1px solid ${theme.palette.error.dark}`,
          },
        },
        outlinedWarning: {
          border: `1px solid ${theme.palette.warning.dark}`,
          color: theme.palette.warning.dark,
          "&:hover": {
            backgroundColor: theme.palette.warning.lighter,
            border: `1px solid ${theme.palette.warning.dark}`,
          },
        },
        text: {
          color: theme.palette.text.secondary,

          "&:hover": {
            backgroundColor: "transparent",
          },
        },
        textInherit: {
          color: theme.palette.text.secondary,
          "&:hover": {
            backgroundColor: theme.palette.action.selected,
          },
        },
      },
    },
  };
}
